<script>
export default {
  name: "ToggleDisplay",
  props: ['isOpening'],
  render() {
    return this.isOpening ? this.$slots.default() : null
  }
}
</script>

<style scoped>

</style>